import type React from "react";
import { ManagementModal } from "app/pages/sales-intelligence/common-components/modals/ManagementModal/ManagementModal";
import { translate } from "app/filters/i18nFilter";
import { allTrackers } from "app/services/track/track";
import { getIntegrationNameFromUrl } from "app/pages/sales-intelligence/common-components/export-table/getIntegrationNameFromUrl";
import { useDiscardModalProps } from "../../hooks/useDiscardModalProps";
import {
    CUSTOM_DETAILS_STYLES,
    CUSTOM_MODAL_STYLES,
} from "app/pages/sales-intelligence/pages/manage-integration/styles/styles";
import { ExportNotification } from "app/pages/sales-intelligence/sub-modules/management/store/type";

type DiscardModalProps = {
    setConfirm(): void;
    tab: string;
};

export const DiscardModal: React.FC<DiscardModalProps> = ({ tab, setConfirm }) => {
    const { integrationName } = getIntegrationNameFromUrl();

    const { setNotification, revertSettingsExport, notification } = useDiscardModalProps(integrationName);

    const onClose = () => {
        allTrackers.dispatchTrackEvent(`${integrationName} integration`, "cancel", `export/${tab}/diacard changes`);
        setNotification(null);
    };

    const onConfirm = () => {
        allTrackers.dispatchTrackEvent(
            `${integrationName} integration`,
            "discard changes",
            `export/${tab}/diacard changes`,
        );
        setNotification(null);
        setConfirm();
        revertSettingsExport();
    };

    const isOpen = notification === ExportNotification.UNSAVED_FIELDS;

    return (
        <ManagementModal
            customStyles={CUSTOM_MODAL_STYLES}
            customDetailsStyles={CUSTOM_DETAILS_STYLES}
            isOpen={isOpen}
            onConfirm={onConfirm}
            onClose={onClose}
            title={translate("si.management.sf.settings_export.modal.discard_fields.notification.title")}
            details={translate("si.management.sf.settings_export.modal.discard_fields.notification.content")}
            confirmBtnText={translate(
                "si.management.sf.settings_export.modal.discard_fields.notification.btn.confirm.label",
            )}
            cancelBtnType="flat"
            cancelBtnText={translate(
                "si.management.sf.settings_export.modal.discard_fields.notification.btn.cancel.label",
            )}
        />
    );
};
